import * as React from "react";
import { ChildInfoMatch } from "./ChildInfoMatch";
import MatchDetail from "../../BoundingBox/MatchDetail";
import { IMatch } from "src/share/types/match";
import usePhotoViewer from "src/share/components/PhotoViewer/usePhotoViewer";

export interface IGMCNgineMatchesProps {
  matches: IMatch[];
  caseInfo: any;
  childInfo: any;
  deleteMatch?: (matchId) => () => void;
  deleting: boolean;
}

const GMCNgineMatches = ({ matches, caseInfo, childInfo, deleteMatch, deleting }: IGMCNgineMatchesProps) => {
  const { handleZoomInImage } = usePhotoViewer();
  return (
    <div className="matches-container">
      <ChildInfoMatch caseInfo={caseInfo} childInfo={childInfo} />
      <div>
        {matches.map((matchData: any) => (
          <div key={matchData.matchId} className="match-info white-background">
            <MatchDetail match={matchData} deleteMatch={deleteMatch} deleting={deleting} onZoomImage={handleZoomInImage}/>
          </div>
        ))}
      </div>
    </div>
  )
};

export default React.memo(GMCNgineMatches);
